// extracted by css-extract-rspack-plugin
export default {"sidebarToggleButton":"SidebarToggle-module__sidebarToggleButton__cTGP3","slimLineTopTabs":"SidebarToggle-module__slimLineTopTabs__NadnJ"};